<template>
  <div class="unsubscribe-page">
    <b-card class="unsubscribe-card mx-auto mt-4">
      <div class="text-center mb-4">
        <h2 class="mb-3">Unsubscribe from Email Updates</h2>
      </div>

      <div v-if="!isUnsubscribed" class="unsubscribe-body">
        <p>
          If you unsubscribe, you will no longer receive automatic email reminders from the Vehicare Customer Portal.
          Please note that you may still receive individual emails sent directly to you by portal users.
        </p>
        <div class="d-flex justify-content-center mt-4">
          <b-button variant="danger" size="lg" :disabled="submitting" @click="unsubscribe">
            {{ submitting ? 'Processing...' : 'Unsubscribe' }}
          </b-button>
        </div>
      </div>

      <div v-else class="text-center success-message">
        <h4 class="mb-3">You have been unsubscribed</h4>
        <p class="mb-0">
          You will no longer receive automatic email reminders from the Vehicare Customer Portal. If you change your
          mind later, you can update your preferences with the support team.
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>
import UnsubscribeService from '@/shared/services/UnsubscribeService';
import ErrorService from '@/shared/services/ErrorService';

export default {
  name: 'UnsubscribePage',
  data() {
    return {
      isUnsubscribed: false,
      submitting: false
    };
  },
  computed: {
    guid() {
      return this.$route.params.guid;
    }
  },
  methods: {
    async unsubscribe() {
      if (!this.guid) {
        ErrorService.createErrorToast(this, 'Unable to unsubscribe. Missing link information.');
        return;
      }

      this.submitting = true;

      try {
        await UnsubscribeService.unsubscribe(this.guid);
        this.isUnsubscribed = true;
      } catch (error) {
        ErrorService.createErrorToast(this, 'Unable to unsubscribe at this time. Please try again later.');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.unsubscribe-page {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.unsubscribe-card {
  width: min(100%, 640px);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.unsubscribe-body {
  font-size: 1rem;
  line-height: 1.7;
}

.success-message {
  padding: 8px 0;
}
</style>
